import { ComposeViewState, PublicFolderComposeViewState } from 'owa-mail-compose-store';
import {
    default as createComposeViewState,
    ComposeViewStateInitProps,
} from './createComposeViewState';
import getFromViewState from './getFromViewState';

export interface PublicFolderComposeViewStateInitProps extends ComposeViewStateInitProps {
    publicFolderId: string;
}

export default async function createPublicFolderComposeViewState(
    props: PublicFolderComposeViewStateInitProps
): Promise<PublicFolderComposeViewState> {
    const composeViewState: ComposeViewState = await createComposeViewState(props);
    const publicFolderComposeViewState = composeViewState as PublicFolderComposeViewState;

    publicFolderComposeViewState.fromViewState = getFromViewState(
        props.from,
        props.meetingRequestItem,
        props.referenceItemId,
        true
    );
    publicFolderComposeViewState.publicFolderId = props.publicFolderId;

    return publicFolderComposeViewState;
}

export function isPublicFolderComposeViewState(
    viewState: ComposeViewState
): viewState is PublicFolderComposeViewState {
    return (<PublicFolderComposeViewState>viewState).publicFolderId !== undefined;
}
